<template>
  <div>
    <el-dialog
      :visible.sync="ifShow"
      :title="title"
      width="600px"
      @close="$emit('closeDialog', false)"
    >
      <div>
        <el-form
          ref="goodsForm"
          :model="titleData"
          :rules="rules"
          label-position="right"
          label-width="7rem"
        >
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="订单编号">
                <span>{{ addPopData.orderNum }}</span>
                <!--<el-input v-model="addPopData.companyName" v-input-filter />-->
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="退单原因" prop="reason" required>
                <el-input v-model="titleData.reason" />
              </el-form-item>
            </el-col>
          </el-row>
          <div class="add-pop-btn" @click="addSubmission('goodsForm')">
            提交
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import { deleteStorageCmsOrder } from '@/api/monitor/orderInfo'
export default {
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '取消订单'
    },
    popData: {
      type: [Object, String],
      default: ''
    },
    status: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      ifShow: this.dialogShow,
      addPopData: this.popData,
      titleData: {
        reason: ''
      },
      // 正则
      rules: {
        // 联系电话
        customerPhone: [
          { required: true, message: '必填' },
          { validator: this.$validate('phone') }
        ],
        reason: [{ required: true, message: '必填' },
          { validator: this.$character(1, 200, 'checkEmpty'), trigger: 'blur' }
        ]
      }
    }
  },
  created() {},
  methods: {
    // 新增提交按钮
    addSubmission(formName) {
      // 正则匹配
      this.$refs[formName].validate((valid) => {
        if (valid) {
          deleteStorageCmsOrder({
            orderNum: this.addPopData.orderNum,
            id: this.addPopData.id,
            orderType: this.addPopData.orderType,
            goodsCompanyId: this.addPopData.goodsCompanyId,
            transportCompanyId: this.addPopData.transportCompanyId,
            goodsId: this.addPopData.goodsId,
            description: this.titleData.reason
          }).then(data => {
            this.$message({
              message: '取消成功',
              type: 'success'
            })
            this.$emit('getList')
            this.$emit('closeDialog', false)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style scoped lang='scss'>
  .add-pop-btn{
    width:100px;
    height:40px;
    line-height: 40px;
    text-align: center;
    margin: 0 auto;
    background:rgba(190,35,22,1);
    border-radius:4px;
    color: #FFFFFF;
    font-size: 18px;
    cursor: pointer;
  }
</style>
